import {Tailwind} from '@wandb/weave/components/Tailwind';
import numeral from 'numeral';
import React, {memo} from 'react';

import {SkeletonWrapper} from '../../../../../components/Skeleton';

interface UsageCardWithCachedViewProps {
  loading: boolean;
  resource: string;
  usage: number;
}

function getFormattedBytes(usage: number) {
  const usedBytesString = numeral(usage).format('0.0b');

  const usedBytesParts = usedBytesString.match(/([0-9]+\.[0-9])([A-Z]?[B])/i)!;

  return {usedBytesTruncated: usedBytesParts[1], unit: usedBytesParts[2]};
}

const UsageCardWithCachedViewComp: React.FC<UsageCardWithCachedViewProps> = ({
  loading,
  resource,
  usage,
}) => {
  const {usedBytesTruncated, unit} = getFormattedBytes(usage);

  if (loading) {
    return (
      <Tailwind>
        <div className="h-[10rem] w-[10rem] rounded-lg ">
          <SkeletonWrapper>
            <div className="h-[10rem] w-[16rem] rounded-lg bg-moon-250"></div>
          </SkeletonWrapper>
        </div>
      </Tailwind>
    );
  }

  return (
    <Tailwind>
      <div className="flex flex-col items-start justify-start rounded-lg border border-moon-250 bg-white px-24 py-16">
        <div className="mb-10 text-lg font-semibold text-moon-800">
          {resource}
        </div>
        <div className="text-5xl font-semibold text-moon-800">
          {usedBytesTruncated}
          <span className="mr-8 text-2xl">{unit}</span>
        </div>
      </div>
    </Tailwind>
  );
};

export const UsageCardWithCachedView = memo(UsageCardWithCachedViewComp);
